import React from 'react';
import PropTypes from 'prop-types';
import createClass from 'create-react-class';

import { PleaseWaitSpinner, HorizontalButtonSelectorArray } from '../../../../jsxctl/utilctl';
// import { Combo } from '../../atoms';
import { PromoSelectorButtons } from '../promotions';
import { PromoProposalControl } from '../promotions/promo-proposal-control';
import { head, map } from 'lodash';
import { PriceChangeSuggestion, Section } from '../../../mvcapi/models/buyticket';
import { AddToCartRequest } from '../../../mvcapi/models/buyticket/ticketselection';
import { QtySelection } from './qtyselection';
import { AutoFindTicketModel } from '../../../logic/models';
import { useAddTicketsToCartStore } from '../../../stores';
import { TicketModel } from '../../../mvcapi/models/buyticket/submodels';

const tr = require('ts-translate-js').default.boundTR;

interface TicketSelectionProps {
    packageID?: number;
    promoInfo?: any;
    onPromoUpdated?: any;
    eventDateIDs?: number[];
    hiddenPromo?: boolean;
    productType: string;
    overview: boolean;
    maxQty: number;
    limitQtySales: number;
    suggestedQtySales: number;
    internetTicketQTYMultipleOf: number;
    sections?: Section[];
    forceSectionInPromo: boolean;
    onModifyThisStep?: any;
    packages?: any[];
    seePromoLink?: string;
    preferredSelectedSectionId?: number;
    scheduleRange?: any;
    hideBestTicketSelection?: boolean;
    packageNumberForEventDate?: number;
    autoFindTicket?: AutoFindTicketModel;
    clearPreviousSelection?: boolean; // Used to clear the previous selection when the user search for new tickets
    onContentChange?: any;
    onFoundTickets?: any;
    onBuyClick?: any;
    onFindTickets?: any;
    integ?: any;
    useNewSale?: boolean;
    addToCartRequest?: AddToCartRequest; // Optional. Used for price change suggestion.
    onPriceChangeSuggestions?: (priceChangeSuggestions: PriceChangeSuggestion[]) => void; // Optional. Used for price change suggestion.
} 

interface TicketSelectionState {
    numberoftickets: number;
    selectedSection: Section;
    processing: boolean;
    haserror: boolean;
    errormessage: string;
    findingTickets: boolean;
    showPromoSelector: boolean;
}

export const TicketSelection = createClass<TicketSelectionProps, TicketSelectionState>({
    displayName: "TicketSelection",

    propTypes: {
        packageID: PropTypes.number,
        eventDateIDs: PropTypes.array,
        promoInfo: PropTypes.object,
        onPromoUpdated: PropTypes.func,
        hiddenPromo: PropTypes.bool,
        productType: PropTypes.oneOf(["Ticket", "PrepaidCard", "MembershipCard", "Product"]).isRequired, // ProductTypeEnum
        overview: PropTypes.bool.isRequired,
        maxQty: PropTypes.number.isRequired,
        limitQtySales: PropTypes.number.isRequired,
        suggestedQtySales: PropTypes.number,
        sections: PropTypes.array,
        forceSectionInPromo: PropTypes.bool,
        onModifyThisStep: PropTypes.func,
        packages: PropTypes.array,
        seePromoLink: PropTypes.string, // Used to determinate if we have to display a "See our promo" button or not
        packageNumberForEventDate: PropTypes.number, // Used to determinate the "See our promo" button text (plurial or not)
        scheduleRange: PropTypes.shape({
            transactionTag: PropTypes.string,
            maxNumberOfTicketsPerRange : PropTypes.number
        }),
        hideBestTicketSelection: PropTypes.bool,
        useNewSale: PropTypes.bool
    },

    getInitialState () {
        return {
            numberoftickets: 0,
            selectedSection: null,
            processing: false,
            haserror: false,
            errormessage: "",
            findingTickets: false,
            showPromoSelector: false
        };
    },

    getDefaultProps() {
        return {
            packageID: undefined,
            eventDateIDs: undefined,
            promoInfo: undefined,
            hiddenPromo: undefined,
            onPromoUpdated: undefined,
            productType: undefined,
            overview: undefined,
            maxQty: undefined,
            limitQtySales: undefined,
            sections: undefined,
            suggestedQtySales: undefined,
            internetTicketQTYMultipleOf: undefined,
            onModifyThisStep: undefined,
            packages: undefined,
            seePromoLink: undefined,
            packageNumberForEventDate: undefined,
            hideBestTicketSelection: undefined,
            autoFindTicket: undefined,
            onContentChange: undefined,
            onFoundTickets: undefined,
            onBuyClick: undefined,
            onFindTickets: undefined,
            integ: undefined,
            clearPreviousSelection: true,
            forceSectionInPromo: false,
            scheduleRange: null,
            addToCartRequest: null,
            onPriceChangeSuggestions: null,
            useNewSale: false
        };
    },

    componentDidMount() {
        const preferredSelectedSectionId =  useAddTicketsToCartStore.getState().preferredSelectedSectionId;
        if(preferredSelectedSectionId != 0)
            this.setState({ selectedSection: this.props.sections.find((section) => section.ID === preferredSelectedSectionId) });

        this.updateSectionAndAutoFindTicketOnLoad();

        if(this.props.onContentChange !== undefined) this.props.onContentChange();
    },

    componentDidUpdate(prevProps, prevState) {
        if((this.props.autoFindTicket != null && this.props.autoFindTicket != prevProps.autoFindTicket)
            || (this.state.sectionid && this.state.selectedSection !== prevState.selectedSection)) {
            this.updateSectionAndAutoFindTicketOnLoad();
        }
        if(this.props.onContentChange !== undefined) this.props.onContentChange();
    },

    updateSectionAndAutoFindTicketOnLoad() {
        let sectionid = this.getSelectedSectionId();
        
        if(sectionid != 0 && (this.state.selectedSection && sectionid != this.state.selectedSection.ID) || this.props.autoFindTicket != null) {
            
            this.autoFindTicketOnChange(this.props.autoFindTicket.qty, this.props.autoFindTicket.sectionid);
        }
    },

    autoFindTicketOnChange(qty, sectionid) {
        this.findTickets(qty, sectionid, this.getSelectedSectionName());
    },

    // le id de section peut être zéro cherchera partout dans la salle (meilleure place)
    findTickets(newqty, sectionid, sectionName) {
        console.log("---- findTickets call:", this.props.clearPreviousSelection, newqty);
        this.setState({ findingTickets: true, numberoftickets: newqty });

        if(this.props.scheduleRange != null) {
            tsapp.svc.BuyTicket.findTicketsByScheduleRange(tsapp.mvcapi, this.props.eventDateIDs[0], newqty, this.props.scheduleRange, this.handleFindTicketsSuccess);
        }
        else if(this.props.packageID == null) {
            tsapp.svc.BuyTicket.findTickets(tsapp.mvcapi, this.props.eventDateIDs[0], newqty, this.handleFindTicketsSuccess, sectionid, "", this.props.clearPreviousSelection);
        }
        else
        {
            tsapp.svc.BuyTicket.findPackageTickets(tsapp.mvcapi, this.props.packageID, this.props.eventDateIDs, newqty, this.handleFindTicketsSuccess, sectionName != "" ? [sectionName] : [], this.props.clearPreviousSelection);
        }

    },
    
    handleFindTickets(newqty) {
        this.findTickets(newqty, this.getSelectedSectionId(), this.getSelectedSectionName());
    },

    handleFindTicketsSuccess(data) {
        let hasError = false;
        let errorMsg = null;

        if (data.IsSuccess)
        {
            this.props.onFoundTickets(true);

            if(this.props.onFindTickets) 
                this.props.onFindTickets(data.foundTickets);

            const sectionid = data.foundTickets as TicketModel[] ? data.foundTickets[0].SectionID : 0;

            console.log("handleFindTicketsSuccess", data.foundTickets, sectionid);

            if(sectionid != 0)
                this.setState({ sectionid: sectionid, selectedSection: this.props.sections.find((section) => section.ID === sectionid) });
        }
        else
        {
            hasError = true;
            errorMsg = data.Message;

            this.props.onFoundTickets(false);
        }

        this.setState({ findingTickets: false });

        this.setState({ haserror: hasError, errormessage: errorMsg });
    },

    handleChangeSection: function(newSectionID) {
        const selectedSection = this.props.sections.find((section) => section.ID === newSectionID);
        this.setState({ selectedSection });
    },

    handleOnModifyClick() {
        this.setState({ findingTickets: false });
        this.props.onModifyThisStep();
    },

    getSelectedSectionId() {


        let sectionid = 0;
        
        if(this.state.selectedSection != null)
            sectionid = this.state.selectedSection.ID;
        
        if(this.props.autoFindTicket != null)
            sectionid = this.props.autoFindTicket.sectionid;

        if(sectionid == 0 && this.props.forceSectionInPromo && this.props.sections.length > 0)
            sectionid = head<Section>(this.props.sections).ID;

        if(sectionid != 0 && this.state.selectedSection == null)
            this.handleChangeSection(sectionid);

        return sectionid;
    },

    getSelectedSectionName() {

        let sectionName = "";
        
        if(this.state.selectedSection != null)
            sectionName = this.state.selectedSection.Name;
        
        if(sectionName == "" && this.props.forceSectionInPromo && this.props.sections.length > 0)
            sectionName = head<Section>(this.props.sections).Name;

        return sectionName;
    },

    render() {
        let content = null;
        let sections = [];
        let defaultSection = { id: 0, name: tr("Chercher les meilleures places") };

        if(this.props.sections !== null)
            //Prépare les données pour le combo de section
            sections = map(this.props.sections, (item) => ({ id: item.ID, name: item.Name }));

        let cmbSections = null;
        // let showSections =   this.props.sections !== null && this.props.productType === "Ticket";
        let isAProduct = (this.props.productType === "Product");
        let isAPackage = (this.props.packageID != undefined);

        let quantityLabel, quantityQuestion;
        if (isAProduct) {
            quantityLabel = tsapp.tr("Quantité désirée ");
            quantityQuestion = tsapp.tr("Quantité désirée ");
        } else if (isAPackage) {
            quantityLabel = tsapp.tr("Votre nombre de forfaits ");
            quantityQuestion = tsapp.tr("Combien de forfaits désirez-vous?");
        } else {
            quantityLabel = tsapp.tr("program.ticketselection.nbrticketlabel") + tr(":");
            quantityQuestion = tsapp.tr("program.ticketselection.nbrtickettitle");
        }

        const promoSelector = <PromoSelectorButtons
            container={this.refs.modalContainerRef}
            packages={this.props.packages} 
            onClose={this.handlePromoSelectorOnClose} 
        />;

        if(this.props.overview) {
            // if(showSections) {
            //     cmbSections = (
            //         <div>
            //             <ul className="list-inline">
            //                 <li><label><strong>{tsapp.tr("program.ticketselection.sectionlabel")}:</strong></label></li>
            //                 <li><Combo className="form-control" readOnly={true} items={sections}
            //                                  selectedValue={this.getSelectedSectionId()} onChange={this.handleChangeSection}/></li>
            //                 <li><button className="btn btn-default btn-xs" type="button" onClick={this.handleOnModifyClick}>{tr("Changer")}</button></li>
            //             </ul>
            //         </div>);
            // }


            content = [
                <div key="ticketQty" className="row">
                    <div className="col-sm-1"></div>
                    <div className="col-sm-10 text-center">
                        <ul className="list-inline">
                            <li><label><strong>{quantityLabel}</strong></label></li>
                            <li>{this.state.numberoftickets}</li>
                            <li><button className="btn btn-default btn-xs" type="button" onClick={this.handleOnModifyClick}>{tr("Changer")}</button></li>
                        </ul>
                    </div>
                    <div className="col-sm-1"></div>
                </div>
            ];

        } else {
            let qtyctrl = null;
            if(this.state.findingTickets) {
                qtyctrl = (
                    <PleaseWaitSpinner size="md"></PleaseWaitSpinner>
                );
            }
            else {
                qtyctrl = <QtySelection eventDateIDs={this.props.eventDateIDs}
                    maxQty={this.props.maxQty}
                    limitQtySales={this.props.limitQtySales}
                    suggestedQtySales={this.props.suggestedQtySales}
                    internetTicketQTYMultipleOf={this.props.internetTicketQTYMultipleOf}
                    onFindTickets={this.handleFindTickets}
                    onContentChange={this.props.onContentChange}>
                </QtySelection>;
            }



            if(this.props.sections !== null) {
                if(this.props.sections.length > 1 || this.props.forceSectionInPromo) {
                    let sectionid = this.getSelectedSectionId();

                    if(this.props.forceSectionInPromo || this.props.hideBestTicketSelection)
                        defaultSection = null;
                    
                    cmbSections = (
                        <div>
                            <h5><strong>{tsapp.tr("program.ticketselection.sectiontitle")}</strong></h5>

                            <div className="inline-block">
                                <HorizontalButtonSelectorArray defaultItem={defaultSection}
                                                               items={sections}
                                                               optionalSelectionText={tr("Sélectionnez une section")}
                                                               valueField="id"
                                                               textField="name"
                                                               selectedValue={sectionid}
                                                               maxItemsForButtons={4}
                                                               onClick={this.handleChangeSection} />
                            </div>
                        </div>
                    );
                }
            }

            let errorMessage = null;
            if(this.state.haserror)
                errorMessage = <div className="alert alert-danger"><strong>{this.state.errormessage}</strong></div>;
            
            // var promoProposalCtl;

            const promoInfo = (this.props.promoInfo != null) ? this.props.promoInfo : undefined;

            content = [

                <div key="sections" className="row">
                    <div className="col-xs-12 text-center">
                        {cmbSections}
                    </div>
                </div>,

                promoInfo && <div key="promotion" className="row">
                    <div className="col-xs-12 text-center">
                        <PromoProposalControl 
                            promoInfo={promoInfo}
                            hiddenPromo={this.props.hiddenPromo}
                            showProposalMessage={true}
                            onPromoUpdated={this.props.onPromoUpdated}
                            onContentChange={this.props.onContentChange} 
                            addToCartRequest={this.props.addToCartRequest} 
                            onPriceChangeSuggestions={this.props.onPriceChangeSuggestions}
                            isAPackageSale={isAPackage}
                        />
                    </div>
                </div>,   
                
                <div key="ticketQty" className="row">
                    <div className="col-sm-12 text-center">
                        <h5><strong>{quantityQuestion}</strong></h5>
                        {qtyctrl}
                    </div>
                </div>,

                <div key="errors" className="errorMessage row">
                    <div className="col-sm-12 text-center">
                        {errorMessage}
                    </div>
                </div>
            ];
        }

        return  <>
            <div ref={this.refs.modalContainerRef} />
            {this.state.showPromoSelector && promoSelector }
            <div className="ticketselection">{content}</div>
        </>;
    }
});